export default __webpack_public_path__ + "static/epilogue-c7ecfaf4321b532060a14c6f656aac8d.svg";